import type { Point3 } from '../detection/types';

export interface Viewport {
  /** Taille du canvas (px). */
  readonly width: number;
  readonly height: number;
  /** Ratio largeur/hauteur de l'image à laquelle se rapportent les points. */
  readonly sourceAspect: number;
  /** Comme `object-fit` de la vidéo affichée sous le canvas. */
  readonly fit: 'contain' | 'cover';
  /** Vidéo affichée en miroir (sa propre caméra). */
  readonly mirror: boolean;
}

export type Projector = (p: Point3) => { x: number; y: number };

/** Coordonnées normalisées MediaPipe → pixels du canvas, alignées sur la vidéo affichée. */
export function makeProjector(v: Viewport): Projector {
  if (!(v.width > 0 && v.height > 0 && v.sourceAspect > 0)) throw new Error('viewport invalide');
  const pick = v.fit === 'contain' ? Math.min : Math.max;
  const scale = pick(v.width / v.sourceAspect, v.height);
  const w = scale * v.sourceAspect;
  const h = scale;
  const ox = (v.width - w) / 2;
  const oy = (v.height - h) / 2;
  return (p) => ({ x: ox + (v.mirror ? 1 - p.x : p.x) * w, y: oy + p.y * h });
}
